import { render, staticRenderFns } from "./classes.view.vue?vue&type=template&id=0abc7250&scoped=true&"
import script from "./classes.view.ts?vue&type=script&lang=ts&"
export * from "./classes.view.ts?vue&type=script&lang=ts&"
import style0 from "./classes.view.scss?vue&type=style&index=0&id=0abc7250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abc7250",
  null
  
)

export default component.exports